// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"styles--tooltipWrapper--13tqm","tooltip":"styles--tooltip--1lLxG"};